<script>
import page from 'Pages/_contentSection/products/-productFilter.vue';
export default page;
</script>
